import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import { ImageModule } from 'primeng/image';

@Component({
  selector: 'app-gestor-submenu',
  standalone: true,
  imports: [ImageModule, CommonModule,RouterLink, RouterLinkActive, RouterOutlet],
  templateUrl: './gestor-submenu.component.html',
  styleUrl: './gestor-submenu.component.scss'
})
export class GestorSubmenuComponent {
  menuItems = [
    {
      title: 'Solicitudes',
      description:'Gestiona las solicitudes de vinculación enviadas por los clubes',
      class: 'pi pi-inbox text-4xl text-green-500',
      routerLink: 'solicitudes',
    },
    {
      title: 'Vinculaciones',
      description:'Gestiona y registra vinculacioness',
      class: 'pi pi-user-plus text-4xl text-green-500',
      routerLink: 'vinculaciones',
    },
    {
      title: 'Clubes',
      description:'Visualiza los miembros de los clubes',
      class: 'pi pi-users text-4xl text-green-500',
      routerLink: 'clubes',
    }
  ]
}
